import { useTranslations } from '@vocab/react';
import { Box, Heading, Stack, Text } from 'braid-design-system';

import translations from './.vocab';
import fixing from './images/fixing.svg';

interface GenericProfileErrorProps {
  titleKey?: 'GENERIC_PROFILE_ERROR_TITLE' | 'PROFILE_NOT_FOUND_TITLE';
  descriptionKey?:
    | 'GENERIC_PROFILE_ERROR_DESCRIPTION'
    | 'PROFILE_NOT_FOUND_DESCRIPTION';
}

export const GenericProfileError = ({
  titleKey = 'GENERIC_PROFILE_ERROR_TITLE',
  descriptionKey = 'GENERIC_PROFILE_ERROR_DESCRIPTION',
}: GenericProfileErrorProps) => {
  const { t } = useTranslations(translations);

  const title = t(titleKey);
  const description = t(descriptionKey);

  return (
    <Box
      display="flex"
      justifyContent="center"
      paddingY="xxlarge"
      paddingX="small"
      marginTop="xxxlarge"
    >
      <Box maxWidth="xsmall">
        <Stack space="large" align="center">
          <Box dangerouslySetInnerHTML={{ __html: fixing }} />
          <Heading align="center" level="2" weight="regular">
            {title}
          </Heading>
          <Text align="center">{description}</Text>
        </Stack>
      </Box>
    </Box>
  );
};
